import { PayloadAction } from "@reduxjs/toolkit";
import { put, takeLatest } from "redux-saga/effects";
import { AxiosResponse } from "axios";

import { ToastNotifyError } from "../../../components/ToastNotify";
import { ENDPOINTS } from "../../../config/endpoints";
import api from "../../../services/apiService";
import { SOME_ERR, fallbackTranslations } from "../../../data/constants";
import { callFetchEncryptionKey, callFetchEncryptionSuccess, callValidateSmartcashAccount, callValidateSmartcashAccountFailure, callValidateSmartcashAccountSuccess } from "../../slices/smartCashSlice";

function* fetchEncryptionKey(action: PayloadAction<any>): Generator {
  let payload = action.payload;
  try {
    const response: any = (yield api.request({
      method: "POST",
      url: ENDPOINTS.SMARTCASH.fetchEncryptionKey(),
      data: payload.data,
    })) as AxiosResponse;
    if (response?.data?.statusCode === 200) {
      payload?.successCallback?.();
      yield put(callFetchEncryptionSuccess(response.data.result));
    } else {
      payload?.errorCallback?.();
      ToastNotifyError(fallbackTranslations[response.data.message || SOME_ERR]);
    }
  } catch (error) {
    ToastNotifyError(fallbackTranslations[SOME_ERR]);
  }
}

function* validateSmartcashAccount(action: PayloadAction<any>): Generator {
  let payload = action.payload;
  try {
    const response: any = (yield api.request({
      method: "POST",
      url: ENDPOINTS.SMARTCASH.validateSmartcashAccount(),
      data: payload.data,
    })) as AxiosResponse;
    if (response?.data?.statusCode === 200) {
      yield put(callValidateSmartcashAccountSuccess(response));
      payload?.successCallback?.(response.data?.result);
    } else {
      yield put(callValidateSmartcashAccountFailure(response));
      payload?.errorCallback?.(response.data);
    }
  } catch (error) {
    ToastNotifyError(fallbackTranslations[SOME_ERR]);
  }
}

export default function* root(): Generator {
  yield takeLatest(callFetchEncryptionKey.type, fetchEncryptionKey);
  yield takeLatest(callValidateSmartcashAccount.type, validateSmartcashAccount);
}
